import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import api from "../utils/api";
import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";

function TrialModalOpen({ visable, Close }) {
  // 1. Declare ALL your hooks first at the very top level
  const [selectedTrialClass, setSelectedTrialClass] = useState("Class 2");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const count = useSelector((state) => state.activeComponent.value);
  const dispatch = useDispatch();

  // 2. Early return goes AFTER all hooks have been called
  if (!visable) return null;

  const handleStartTrial = async () => {
    setLoading(true);
    try {
      const res = await api.post("/assign-trial", {
        selectedClass: selectedTrialClass,
      });

      if (res.data.success) {
        localStorage.setItem("postUser", JSON.stringify(res.data.user));
        Close(); // Modal'ı düzgün kapat
        window.location.reload(); // Sayfayı yenileyerek tam senkronizasyon sağla
      }
    } catch (error) {
      console.error("Trial start error:", error);
      alert(error.response?.data?.message || "Deneme paketi başlatılamadı.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-transparent bg-opacity-65 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 text-center transform transition-all">
        <div className="flex items-center justify-between ">
          <div className="flex items-center group cursor-pointer">
            <img src="icons.png" alt="icon" className="w-20 h-20 rounded-2xl" />
          </div>
          <button
            onClick={() => navigate("/login")}
            className=" text-gray-600 flex transition-colors w-auto h-auto p-1 bg-red-500 hover:bg-gray-100 text-center rounded-full"
          >
            <X className="w-8 h-8 text-white hover:text-red-500" />
          </button>
        </div>

        <h2 className="text-2xl font-bold text-gray-800 mb-2">
          Uygulamamıza Hoş Geldiniz!
        </h2>
        <p className="text-gray-600 text-sm mb-6">
          Henüz aktif bir paketiniz bulunmuyor. Uygulamamızı tam özellikleriyle
          keşfetmeniz için size **5 günlük ücretsiz deneme** tanımlıyoruz!
          Lütfen başlamak istediğiniz sınıfı seçin:
        </p>

        <div className="grid grid-cols-3 gap-3 mb-6">
          {["Class 2", "Class 3", "Class 4"].map((cls) => (
            <button
              key={cls}
              type="button"
              onClick={() => setSelectedTrialClass(cls)}
              className={`py-3 px-2 rounded-xl font-semibold text-sm transition-all border-2 ${
                selectedTrialClass === cls
                  ? "border-indigo-600 bg-indigo-50 text-indigo-700 shadow-sm"
                  : "border-gray-200 bg-white text-gray-700 hover:border-gray-300"
              }`}
            >
              {cls}
            </button>
          ))}
        </div>

        <button
          onClick={handleStartTrial}
          disabled={loading}
          className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3 rounded-xl shadow-lg transition-all duration-200 disabled:opacity-50"
        >
          {loading ? "Tanımlanıyor..." : "5 Günlük Ücretsiz Denemeyi Başlat"}
        </button>

        <p className="text-xs text-gray-400 mt-4">
          Deneme süresi sonunda kartınızdan otomatik çekim yapılmaz.
        </p>
      </div>
    </div>
  );
}

export default TrialModalOpen;
